import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestGetInventoryBoxesQrsList = async (
  params: GetListRequestParams
): Promise<GetListResponse<InventoryBoxQrsListItem>> => {
  return await instance.get(ApiRoutesInventory.AllInventoryBoxesQrs, {
    params
  });
};
